import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  similarVehiclesTitle: {
    marginBottom: 30,
    fontSize: 36,
    lineHeight: 1.22,
    fontWeight: 500,
  },
  container: {
    marginBottom: 25,
    scrollMarginTop: "100px",
    [theme.breakpoints.down("sm")]: {
      minHeight: 137,
      margin: "25px 0",
    },
  },
  nearbyVehicleMake: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
  },
  nearbyVehicleModel: {
    color: theme.palette.text.secondary,
  },
  mobileCenteredText: {
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
    },
  },
  desktopFlex: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "flex-start",
    },
  },
  similarVehicleLinks: {
    textDecoration: "none",
  },
}));
